module.exports = __webpack_public_path__ + "img/DN.c2332ee0.webp";